import axiosInstance from '../utils/AxiosConfig';

export const getCategoriesByLocation = async (locationId) => {
    try {
        const response = await axiosInstance.get(`/category_view/${locationId}`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        return [];
    } 
};

export const getCategoryTreeByLocation = async (locationId) => {
    try {
        const response = await axiosInstance.get(`/category_view/${locationId}`);
        return response.data.data; // Ya retorna árbol jerárquico
    } catch (error) {
        console.error('Error fetching category tree:', error);
        return [];
    } 
};

export const updateCategoryAndSubCategories = async (categoryId, categoryData) => {
    try {
        const response = await axiosInstance.put(`/category_view/${categoryId}`, categoryData);
        return response.data.data;
    } catch (error) {
        console.error('Error updating categories:', error);
        throw error;
    } 
};

export const deleteCategory = async (categoryId) => {
    try {
        await axiosInstance.delete(`/category_view/${categoryId}`);
        return true;
    } catch (error) {
        console.error('Error deleting category:', error);
        throw error;
    } 
};

export const addCategory = async (categoryData) => {
    try {
        const response = await axiosInstance.post(`/category_view`, categoryData);
        return response.data.data;
    } catch (error) {
        console.error('Error adding category:', error);
        throw error;
    }
};